import { HIDE_NOTIFICATION, SHOW_NOTIFICATION, } from '../actions/NotificationActions';
// eslint-disable-next-line default-param-last
export default (state = {}, { message, notificationType, type }) => {
    switch (type) {
        case SHOW_NOTIFICATION: {
            return {
                message,
                notificationType,
            };
        }
        case HIDE_NOTIFICATION: {
            return {};
        }
        default: {
            return state;
        }
    }
};
